module.exports = __webpack_public_path__ + "h5/img/id_front.7a5c54dd.png";